module.exports = __webpack_public_path__ + "static/media/Murphy Cavaletti klein.acc47d4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Murphy Cavaletti klein.jpg
// module id = 349
// module chunks = 0